<template>
  <div class="married-page">
    <!-- Header Section -->
    <AppHeader 
      header-text="Drivers in your state can save up to $600/year"
      button-text="FREE CALL"
    />

    <!-- Progress Bar -->
    <div class="progress-container">
      <div class="progress-bar">
        <div class="progress-fill"></div>
      </div>
    </div>

    <!-- Navigation -->
    <div class="navigation">
      <div class="container">
        <button class="back-btn" @click="goBack">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          Previous Question
        </button>
      </div>
    </div>

    <!-- Married Question Section -->
    <section class="married-section">
      <div class="container">
        <div class="married-content">
          <h1 class="married-title">Are you currently married?</h1>
          
          <div class="married-options">
            <button 
              :class="['married-button', { 'selected': selectedOption === 'yes' }]"
              @click="selectMarriedStatus('yes')"
            >
              Yes
            </button>
            <button 
              :class="['married-button', { 'selected': selectedOption === 'no' }]"
              @click="selectMarriedStatus('no')"
            >
              No
            </button>
          </div>
        </div>
      </div>
    </section>

    <!-- Footer Links -->
    <AppFooter />
  </div>
</template>

<script>
import AppHeader from '@/components/AppHeader.vue'
import AppFooter from '@/components/AppFooter.vue'
import { submitDataAndLog } from '@/utils/localStorage'

export default {
  name: 'MarriedPage',
  components: {
    AppHeader,
    AppFooter
  },
  data() {
    return {
      selectedOption: null,
      userQuoteData: null
    }
  },
  mounted() {
    this.loadUserData()
  },
  methods: {
    loadUserData() {
      const storedData = localStorage.getItem('quoteData')
      if (storedData) {
        try {
          this.userQuoteData = JSON.parse(storedData)
          // 加载之前选择的婚姻状态（如果有的话）
          if (this.userQuoteData.marital_status !== undefined) {
            this.selectedOption = this.userQuoteData.marital_status === 'married' ? 'yes' : 'no'
          }
        } catch (error) {
          console.error('Error parsing stored data:', error)
          this.$router.push('/')
        }
      } else {
        // 如果没有数据，跳转回首页
        this.$router.push('/')
      }
    },
    
    saveUserData() {
      localStorage.setItem('quoteData', JSON.stringify(this.userQuoteData))
    },
    
    async selectMarriedStatus(option) {
      this.selectedOption = option
      
      const maritalStatus = option === 'yes' ? 'married' : 'single'
      
      // 检查是否是添加驾驶员模式
      if (this.userQuoteData.adding_driver && this.userQuoteData.temp_driver) {
        // 添加驾驶员模式：更新临时驾驶员数据
        this.userQuoteData.temp_driver.marital_status = maritalStatus
        console.log('Selected marital status for additional driver:', maritalStatus)
      } else {
        // 主驾驶员模式：更新主驾驶员数据
        this.userQuoteData.marital_status = maritalStatus
        console.log('Selected marital status for primary driver:', maritalStatus)
      }
      
      this.saveUserData()
      
      // 提交数据并记录页面提交事件
      await submitDataAndLog('married')
      // 跳转到出生月份页面
      this.$router.push('/birth-month')
    },
    
    goBack() {
      this.$router.push('/gender')
    }
  }
}
</script>

<style scoped>
/* Page Layout */
.married-page {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

/* Navigation */
.navigation {
  padding: 1rem 0;
}

.back-btn {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: none;
  border: none;
  color: #999;
  font-size: 0.9rem;
  cursor: pointer;
  transition: color 0.3s ease;
}

.back-btn:hover {
  color: #666;
}

/* Married Section */
.married-section {
  padding: 2rem 0 4rem;
  background: #fff;
  flex: 1;
}

.married-content {
  text-align: center;
  max-width: 800px;
  margin: 0 auto;
}

.married-title {
  font-size: 2rem;
  font-weight: 600;
  color: #333;
  margin-bottom: 3rem;
  line-height: 1.3;
}

.married-options {
  display: flex;
  gap: 2rem;
  justify-content: center;
  align-items: center;
}

.married-button {
  padding: 1.5rem 3rem;
  border: 2px solid #e9ecef;
  border-radius: 8px;
  background: #fff;
  color: #007bff;
  font-size: 1.2rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  min-width: 150px;
  min-height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.married-button:hover {
  border-color: #007bff;
  background: #f8f9fa;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0,123,255,0.15);
}

.married-button.selected {
  border-color: #007bff;
  background: #007bff;
  color: #fff;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0,123,255,0.3);
}

/* Mobile Layout */
@media (max-width: 768px) {
  .married-content {
    padding: 0 1rem;
  }

  .married-title {
    font-size: 1.5rem;
    margin-bottom: 2rem;
    padding: 0 1rem;
  }

  .married-options {
    flex-direction: row;
    gap: 1rem;
    justify-content: center;
  }

  .married-button {
    padding: 1.2rem 1.5rem;
    font-size: 1.1rem;
    min-width: 120px;
    min-height: 70px;
    flex: 1;
    max-width: 150px;
  }

  .married-section {
    padding: 1.5rem 0 2rem;
  }
}

@media (max-width: 480px) {
  .married-title {
    font-size: 1.3rem;
    margin-bottom: 1.5rem;
  }

  .married-options {
    gap: 0.8rem;
    padding: 0 1rem;
  }

  .married-button {
    padding: 1rem 1rem;
    font-size: 1rem;
    min-width: 100px;
    min-height: 60px;
    flex: 1;
    max-width: 140px;
  }

  .married-section {
    padding: 1rem 0;
  }
}
</style>
